import type { Handlers } from '@/types/Metrics';

interface TaboolaEventPayload {
  notify: string;
  id: string;
  name: string;
  [key: string]: any;
}

declare const _tfa: TaboolaEventPayload[];

export default function (args: Handlers['taboola']) {
  const { tracker } = useRuntimeConfig().public;

  if (!tracker.taboolaId) {
    return;
  }

  const [eventName, parameters] = args;

  try {
    const eventPayload = buildTaboolaEventPayload(
      tracker.taboolaId,
      eventName,
      parameters,
    );

    trackTaboolaEvent(eventPayload);
  } catch (err) {
    console.error('Error executing Taboola tracking:', err);
  }
}

function buildTaboolaEventPayload(
  taboolaId: string,
  eventName: string,
  parameters?: Record<string, any>,
): TaboolaEventPayload {
  const basePayload = {
    notify: 'event',
    id: taboolaId,
    name: eventName,
  };

  if (eventName === 'custom' && parameters?.eventName) {
    const { eventName: customEventName, ...rest } = parameters;

    return {
      ...basePayload,
      name: customEventName,
      ...rest,
    };
  }

  return {
    ...basePayload,
    ...parameters,
  };
}

function isTaboolaAvailable(): boolean {
  return typeof _tfa !== 'undefined' && Array.isArray(_tfa);
}

function trackTaboolaEvent(eventPayload: TaboolaEventPayload): void {
  if (!isTaboolaAvailable()) {
    console.warn('Taboola tracking: _tfa array is not available');

    return;
  }

  try {
    _tfa.push(eventPayload);
  } catch (error) {
    console.error('Error pushing event to Taboola:', error);
  }
}
